import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {withAlert} from 'react-alert';
import {postRequest, uploadFile} from "../routes/Routes";
import {loadCategories} from "../common/Common";
import Select from "react-select";
import Expand from 'react-expand-animated';
import {isMobile} from 'react-device-detect';
import {getUser} from "../auth/Auth";
import '../assets/css/Home.css';

import addImage from '../assets/images/add.png';
import Loading from "../components/Loading";

class ManageStore extends Component {
    constructor(props) {
        super(props);
        this.state = {
            products: [],
            user: null,
            action: '',
            categories: [],
            error: false,
            errorMessage: null,
            loading: false,
            loadingProducts: true
        };
        this.fileInput = React.createRef();
    }

    componentDidMount() {
        getUser(this.props.history).then(data => {
            this.setState({user: data});
            loadCategories().then(data => {
                this.setState({categories: data});
                this.loadProducts();
            }).catch(() => null);
        });
    }

    render() {
        if (this.state.user) {
            return (
                this.state.loadingProducts ?
                    <Loading/>
                    : <div className="container category-list partner-list">
                        {this.state.action === 'Add Product' ?
                            <div className="change-password-component">
                                <h3 className="form-heading">
                                    Add Product
                                </h3>
                                <form onSubmit={this.formSubmit} className="add-product-form">
                                    <div className="form-group">
                                        <input className="form-control" type="text" placeholder='Product Name*' id="name"
                                               required/>
                                    </div>
                                    <div className="form-group">
                                        <input className="form-control" type="number" placeholder='Stock*' id="stock"
                                               min="0" required/>
                                    </div>
                                    <div className="form-group">
                                        <input className="form-control" type="number" placeholder='Price*' id="price"
                                               min="0.00" step="0.01" required/>
                                    </div>
                                    <div className="form-group">
                                        <input className="form-control" type="text" placeholder='Part Number*'
                                               id="partNumber" required/>
                                    </div>
                                    <div className="form-group">
                                        <Select className="basic-single btn w-100" placeholder="Category" name="category"
                                                id="category" options={this.state.categories}
                                                getOptionValue={option => option['id']}
                                                getOptionLabel={option => option['name']}/>
                                    </div>
                                    <div className="form-group">
                                    <textarea className="form-control custom-textarea" placeholder='Product Description'
                                              id="description"/>
                                    </div>
                                    <div className="custom-file">
                                        <input type="file" className="custom-file-input" id="image" accept="image/*"
                                               ref={this.fileInput} multiple/>
                                        <label className="custom-file-label" htmlFor="image">
                                            <img src={addImage} alt="Add Image Icon"/>
                                            <div className="image-uploader-label">
                                                Drag & drop or <span className="blue-font">select from your files</span>
                                            </div>
                                        </label>
                                        <small id="image" className="form-text text-muted">
                                            Add Product Images
                                        </small>
                                    </div>
                                    {this.state.error &&
                                    <div className="alert alert-danger" role="alert">
                                        {this.state.errorMessage}
                                    </div>}
                                    <div className="form-buttons edit-account-buttons">
                                        <button type="submit" className="btn blue-button login-button"
                                                disabled={this.state.loading}>
                                            {this.state.loading ?
                                                <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                                      aria-hidden="true"/>
                                                : null
                                            }Confirm
                                        </button>
                                        <button className="btn blue-border-button login-button" id=""
                                                onClick={this.actionClick}>Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                            : [
                                <div className="d-flex bd-highlight w-100 contact-us-details" key="div">
                                    <div className="p-2 flex-fill bd-highlight">
                                        <h1 className="heading">Store Products</h1>
                                    </div>
                                    <div className="p-2 flex-fill bd-highlight action-div">
                                        <button className="btn blue-button login-button" id="Add Product"
                                                onClick={this.actionClick}>
                                            Add Product
                                        </button>
                                    </div>
                                </div>,
                                <hr key="hr"/>,
                                this.getProductBody()
                            ]
                        }
                    </div>
            );
        } else {
            return null;
        }
    }

    getProductBody = () => {
        let productBody = [];
        this.state.products.forEach((product, index) => {
            productBody.push(
                <div key={index}>
                    <div className="d-flex bd-highlight w-100 order order-container"
                         onClick={() => this.expandProduct(index)}>
                        <div className="p-2 flex-fill bd-highlight">
                            <h4>{product.name}</h4>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Stock: <strong>{product.stock} items</strong></div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <div>Price: <strong>Rs.{product.price}</strong></div>
                        </div>
                    </div>
                    <Expand open={product.open}>
                        <div className="order-container">Description: <strong>{product.description}</strong></div>
                        <div className="order-container">
                            <form onSubmit={this.formSubmit} className="add-product-form">
                                <input className="form-control" type="text" id="id" defaultValue={product.id}
                                       hidden/>
                                <input className="form-control" type="text" id="index" defaultValue={index} hidden/>
                                <table className="account-details">
                                    <tbody>
                                    <tr>
                                        <td>Product Name</td>
                                        <td>
                                            <div className="form-group">
                                                <input className="form-control" type="text"
                                                       placeholder='Product Name*'
                                                       id="name" defaultValue={product.name} required/>
                                            </div>
                                        </td>
                                        {!isMobile ?
                                            <td className="action-div">
                                                <button type="submit"
                                                        className="btn blue-border-button login-button">
                                                    Update Product
                                                </button>
                                            </td>
                                            : null
                                        }
                                    </tr>
                                    <tr>
                                        <td>Product Stock</td>
                                        <td>
                                            <div className="form-group">
                                                <input className="form-control" type="number" placeholder='Stock*'
                                                       id="stock" min="0" defaultValue={product.stock} required/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Product Price</td>
                                        <td>
                                            <div className="form-group">
                                                <input className="form-control" type="number" placeholder='Price*'
                                                       id="price" min="0" step="0.01" defaultValue={product.price}
                                                       required/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Part Number</td>
                                        <td>
                                            <div className="form-group">
                                                <input className="form-control" type="text"
                                                       placeholder='Part Number*'
                                                       id="partNumber" defaultValue={product.part_number} required/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Product Category</td>
                                        <td>
                                            <div className="form-group">
                                                <Select className="basic-single btn w-100" placeholder="Category"
                                                        name="category" id="category"
                                                        options={this.state.categories}
                                                        defaultValue={this.state.categories.filter((item) => item.id === product.category_id)}
                                                        getOptionValue={option => option['id']}
                                                        getOptionLabel={option => option['name']}/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Product Description</td>
                                        <td>
                                            <div className="form-group">
                                                <textarea className="form-control custom-textarea"
                                                          placeholder='Product Description' id="description"
                                                          defaultValue={product.description}/>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Product Images</td>
                                        <td>
                                            <div className="custom-file">
                                                <input type="file" className="custom-file-input" id="image"
                                                       accept="image/*"
                                                       ref={this.fileInput} multiple/>
                                                <label className="custom-file-label" htmlFor="image">
                                                    <img src={addImage} alt="Add Image Icon"/>
                                                    <div className="image-uploader-label">
                                                        Drag & drop or <span className="blue-font">select from your files</span>
                                                    </div>
                                                </label>
                                                <small id="image" className="form-text text-muted">
                                                    Add Product Images
                                                </small>
                                            </div>
                                        </td>
                                    </tr>
                                    {isMobile ?
                                        <tr>
                                            <td className="action-div" colSpan="2">
                                                <button type="submit"
                                                        className="btn blue-border-button login-button">
                                                    Update Product
                                                </button>
                                            </td>
                                        </tr>
                                        : null
                                    }
                                    </tbody>
                                </table>
                            </form>
                        </div>
                    </Expand>
                </div>
            )
        });

        return productBody;
    };

    loadProducts = () => {
        let {products, user} = this.state;
        postRequest({
            name: user.partner.name,
            endpoint: '/api/partners/products',
            token: this.state.user.token
        }).then(response => {
            if (response.status === 200) {
                if (response.data.error) {
                    this.props.alert.error(response.data.message);
                } else {
                    response.data.products.forEach((product) => {
                        product.open = false;
                        products.push(product);
                    });
                    this.setState({products: products, loadingProducts: false});
                }
            } else {
                this.props.alert.error(response.data.message);
            }
        });
    };

    expandProduct = (index) => {
        let {products} = this.state;
        products[index].open = !products[index].open;
        this.setState({products: products});
    };

    actionClick = (event) => {
        event.preventDefault();
        this.setState({action: event.target.id});
    };

    formSubmit = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        if (this.state.action === 'Add Product' || this.state.action === '') {
            if (event.target.category.value !== '') {
                const data = new FormData();
                data.append('name', event.target.name.value);
                data.append('stock', event.target.stock.value);
                data.append('price', event.target.price.value);
                data.append('part_number', event.target.partNumber.value);
                data.append('description', event.target.description.value);
                data.append('category_id', event.target.category.value);
                data.append('partner_id', this.state.user.partner.id);
                data.append('id', this.state.action === '' ? event.target.id.value : null);
                if (this.fileInput.current && this.fileInput.current.files.length > 0) {
                    for (let i = 0; i < this.fileInput.current.files.length; i++) {
                        data.append(`images[${i}]`, this.fileInput.current.files[i]);
                    }
                }
                uploadFile(data, '/api/products', this.state.user.api_token).then(async response => {
                    if (response.status === 200) {
                        if (response.data.error) {
                            this.props.alert.error(response.data.message);
                        } else {
                            let products = this.state.products;
                            if (this.state.action === '') {
                                products[event.target.index.value] = response.data.product;
                            } else {
                                response.data.product = {...response.data.product, open: false};
                                products.push(response.data.product);
                            }
                            this.setState({
                                products: products,
                                action: '',
                                error: false,
                                errorMessage: null
                            });
                            this.props.alert.success(this.state.action === '' ? "Successfully Updated Product" : "Successfully Created Product");
                        }
                    } else {
                        this.props.alert.error(response.data.message);
                    }
                    this.setState({
                        loading: false
                    });
                });
            } else {
                this.setState({error: true, errorMessage: 'Please Select a Category', loading: false})
            }
        }
    }
}

export default withAlert()(withRouter(ManageStore));